import PropTypes from "prop-types";
import React, { useState } from "react";
import { SnackbarProvider } from "notistack";
import Hidden from "@mui/material/Hidden";
import CssBaseline from "@mui/material/CssBaseline";
import { withStyles } from "@mui/styles";
import { ThemeProvider } from "@mui/material/styles";

import { theme } from "../../config/theme";
import { Navigator } from "../../components";
import { drawerWidth, styles } from "./styles";

function BaseLayout({ classes, children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3}>
        <div className={classes.root}>
          <CssBaseline />
          <nav className={classes.drawer}>
            <Hidden smUp implementation="js">
              <Navigator
                PaperProps={{ style: { width: drawerWidth } }}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
              />
            </Hidden>
            <Hidden xsDown implementation="css">
              <Navigator PaperProps={{ style: { width: drawerWidth } }} />
            </Hidden>
          </nav>
          <div className={classes.app}>
            <main className={classes.main}>{children}</main>
          </div>
        </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

BaseLayout.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(BaseLayout);
